import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { FuseLoadingService } from '@fuse/services/loading/loading.service';
import { ButtonLoadingService } from 'app/modules/shared/button-loading.service';
import { finalize, Observable, take } from 'rxjs';

export const fuseLoadingInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const fuseLoadingService = inject(FuseLoadingService);
    const loadingService = inject(ButtonLoadingService);
    let handleRequestsAutomatically = false;

    fuseLoadingService.auto$.pipe(take(1)).subscribe((value) => {
        handleRequestsAutomatically = value;
    });

    // If Auto mode is turned off, do nothing
    if (!handleRequestsAutomatically) {
        return next(req);
    }

    // Skip global loading bar if request explicitly opts out
    const skipGlobal = req.headers.has('X-Skip-Global-Loading');
    // Set the loading status to true
    if (!skipGlobal) {
        fuseLoadingService._setLoadingStatus(true, req.url);
        loadingService?.show(); // Call show() only if loadingService is defined
    }

    return next(req).pipe(
        finalize(() => {
            // Set the status to false when the request completes or encounters an error
            if (!skipGlobal) {
                fuseLoadingService._setLoadingStatus(false, req.url);
                loadingService?.hide(); // Call hide() only if loadingService is defined
            }
        })
    );
};
